import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { HttpQueriesService } from '../Services/http-queries.service';
import { ActivatedRoute } from '@angular/router';
import { StorageService } from '../Services/storage.service';
import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabase } from '@angular/fire/database';
import * as firebase from 'firebase/app'; 

@Component({
  selector: 'app-stand-visiting',
  templateUrl: './stand-visiting.component.html',
  styleUrls: ['./stand-visiting.component.scss']
})
export class StandVisitingComponent implements OnInit {

  stand_basic = {stand_id:null};
  server = null;

  int = 1;
  panel = {display:false, type:1};

  stand = null;
  loading = true;

  selected_doc = null;
  pdfSrc = null;
  pdf_loaded = false;
  pdf_pages = 0;
  page = 1;

  stand_quiz = null;
  selected_qq = null;
  selected_qq_index = 0;

  quiz_loading = false;
  quiz_answers = {};
  quiz_status = null;

  stdconuser = null;
  stdconuser_isexpo = false;

  chatMsgVal = null;

  afdb_ref = null;
  standConvos = [];
  selected_convo = null;

  constructor(private httpservice:HttpQueriesService, private route:ActivatedRoute, private standdata:StorageService, 
    private af: AngularFireModule, private db: AngularFireDatabase, private cdr: ChangeDetectorRef) { 
    this.stand_basic.stand_id = this.route.snapshot.paramMap.get('id');
    this.server = httpservice.getServer();
    this.stdconuser = standdata.getCongresConUser();
    this.saveView();

   
  }

  ngOnInit(){
    this.afdb_ref = firebase.database();
    this.loadStandData();
  }

  saveView(){
    let dt = {stand_id:this.stand_basic.stand_id, inscrit_id:this.standdata.getCongresConUser()['id']};
    this.httpservice.saveStandView(dt).subscribe(val=>{
      
    });
  }

  loadStandData(){
    this.httpservice.getStandData(this.stand_basic).subscribe(val=>{
      this.stand = val;
      this.loading = false;
      this.checkIfUserIsOneOfContacts();
      this.getStandConvosByUser();

    }, error=>{
      this.loading = false;

    })
  }

  checkIfUserIsOneOfContacts(){
    let t = this.stand.contacts.forEach(c=>{
      (c['original_user_id'] == this.stdconuser.id) ? this.stdconuser_isexpo = true : false;
    })
  }

  changeInt(n){
    this.int = n;
    this.panel.type = n;
    (n == 3 || n == 4 || n== 6) ? this.panel.display = false : null;
    (n == 6) ? this.loadStandQuiz() : null;
  }

  showPanelElm(n, $event){
    this.preventAction($event);
    this.panel.display = true;
    this.panel.type = n;
    (n > 0) ? this.int = n : null;
  }

  preventAction($event){
    $event.preventDefault();
  }

  hidePanel($event){
    $event.preventDefault();
    this.panel.display = false;
    this.panel.type = null;
  }

  getStandData(){

  }

  preparewpnumber(number){
    let temp = number.substr(1, number.length -1);
    return temp.split(' ').filter(s => s).join('');
  }

  pdfloaded(pdfData:any){
    this.pdf_loaded = true;
    this.pdf_pages = pdfData.numPages;
  }

  nextPage() {
    this.page < this.pdf_pages ? this.page += 1 : this.page = 1;
  }

  prevPage() {
    this.page > 1 ? this.page -= 1 : this.page = this.pdf_pages;
  }

  visualizeDoc(d){
    this.selected_doc = d;
    this.pdfSrc = d.document_link;
    console.log(this.pdfSrc)
    this.panel.type = 1;
    this.panel.display = true;
  }

  gotoDocList($event){
    $event.preventDefault();
    this.selected_doc = null;
    this.pdfSrc = null;
  }

  loadStandQuiz(){
    if(!this.stand_quiz && !this.quiz_status){
      this.quiz_loading = true;
      let dt = {stand_id:this.stand_basic.stand_id, inscrit_id:this.standdata.getCongresConUser()['id']};
      this.httpservice.getStandQuiz(dt).subscribe(val=>{
        this.stand_quiz = val;
        this.quiz_loading = false;
        this.selected_qq = this.stand_quiz[this.selected_qq_index];
        this.prepareAnswers();

      }, error=>{
        this.quiz_status = error.error;
        this.quiz_loading = false;

      });
    }
  }

  prepareAnswers(){
    for(let i=0; i<this.stand_quiz.length; i++){
      (this.stand_quiz[i]['question_type'] == 0) ? this.quiz_answers[this.stand_quiz[i]['question_id']] = null : this.quiz_answers[this.stand_quiz[i]['question_id']] = [];
    }
  }

  nextQuizQuest(){
    (this.selected_qq_index < this.stand_quiz.length - 1) ? this.selected_qq_index += 1 : null;
    this.selected_qq = this.stand_quiz[this.selected_qq_index];
  }

  prevQuizQuest(){
    (this.selected_qq_index > 0) ? this.selected_qq_index -= 1 : null;
    this.selected_qq = this.stand_quiz[this.selected_qq_index];
  }

  selecteChoice(c){
    if(parseInt(this.selected_qq['question_type'] )== 0){
      this.quiz_answers[this.selected_qq['question_id']] = c.q_choice_id;

    }else{
      (this.quiz_answers[this.selected_qq['question_id']].indexOf(c.q_choice_id) == -1) 
      ? this.quiz_answers[this.selected_qq['question_id']].push(c.q_choice_id) 
      : this.quiz_answers[this.selected_qq['question_id']].splice(this.quiz_answers[this.selected_qq['question_id']].indexOf(c.q_choice_id), 1);

    }
  }

  checkIfChoiceIsChosen(c){
    let bool = false;
    if(parseInt(this.selected_qq['question_type']) == 0){
      bool =  this.quiz_answers[this.selected_qq['question_id']]  == c.q_choice_id;
    
    }else{
      bool = this.quiz_answers[this.selected_qq['question_id']].indexOf(c.q_choice_id) != -1;

    }
    return bool;
  }

  saveAnswers(){
    this.quiz_status = "passed";
    let dt = {standquiz_id:this.selected_qq['standquiz_id'], inscrit_id:this.standdata.getCongresConUser()['id'], answers:this.quiz_answers, score:0};
    this.httpservice.saveStandQuizAnswers(dt).subscribe(()=>{});
  }

  startNewConversation(receiver_id, receiver_name){
    let t = this.checkIfContactBelongsToConvo(receiver_id);
    if(!t){
      this.selected_convo = {convo_key:null, receiver:receiver_id, receiver_name:receiver_name, lastMessage:"Nouvelle conversation.."};

    }else{
      this.selectConversation(t);
    
    }
  }

  startChatFromBottom(receiver_id, receiver_name){
    this.panel.display = true;
    this.panel.type = 5;
    this.startNewConversation(receiver_id, receiver_name);
  }

  checkIfContactBelongsToConvo(receiver_id){
    for(let i=0; i<this.standConvos.length; i++){
      let count = 0;
      for(let j=0;j<this.standConvos[i]['users'].length; j++){
        if(this.standConvos[i]['users'][j].id == receiver_id || this.standConvos[i]['users'][j].id == this.stdconuser.id){
          count += 1;
        }
      }
      
      if(count > 1){
        return this.standConvos[i];
      }
    }
    
    return null;
  }

  selectConversation(conv){
    if(!this.selected_convo || this.selected_convo.convo_key != conv.convo_key){
      this.selected_convo = conv;
      this.selected_convo['messages'] = [];
      this.getConvoMessages();
      this.receiverHasSeen();
    }
  }

  receiverHasSeen(){
    if(this.selected_convo && !this.selected_convo['receiver_seen'][this.stdconuser.id]){
      let updates = {};
      updates['/conversations/' + this.selected_convo['convo_key'] + '/receiver_seen/' + this.stdconuser.id] = true;
      return this.afdb_ref.ref().update(updates);
    }
  }

  whoIsTheReceiver(sc){
    let n = null;
    sc.users.forEach(u=>{
      if(u.id != this.stdconuser.id){
        n = u;
      }
    })
    return n;
  }

  chatInuptValueChange($event){
    this.chatMsgVal = $event.target.value;
    this.cdr.detectChanges();
    if($event.keyCode == 13){
      this.sendChatMsg();
    }
  }

  sendChatMsg(){
    let updates = {};
    let convo_key = this.selected_convo.convo_key ? this.selected_convo.convo_key : null;
    if(!this.selected_convo.convo_key){
      convo_key = this.afdb_ref.ref().child('conversations').push().key;
      this.selected_convo.convo_key = convo_key;
      let u = [ {name: this.stdconuser.civilite + '.'+ this.stdconuser.prenom + ' ' + this.stdconuser.nom, id:this.stdconuser.id}, {name:this.selected_convo.receiver_name, id:this.selected_convo.receiver}];
      this.selected_convo.users = u;
      this.selected_convo.receiver_seen = {};
      this.selected_convo.receiver_seen[this.whoIsTheReceiver(this.selected_convo).id] = false;
      this.selected_convo.receiver_seen[this.stdconuser.id] = true;

      updates['/conversations/' + convo_key + '/convo_key'] = convo_key;
      updates['/conversations/' + convo_key + '/users'] = u;
      
      this.selected_convo['messages'] = [];
      this.getConvoMessages();
    }

    updates['/conversations/' + convo_key + '/lastMessage'] = this.stdconuser.prenom + ' : ' + this.chatMsgVal;
    updates['/conversations/' + convo_key + '/lastTimeStamp'] = Date.now();
    updates['/conversations/' + convo_key + '/receiver_seen/' + this.whoIsTheReceiver(this.selected_convo).id] = false;
    updates['/conversations/' + convo_key + '/receiver_seen/' + this.stdconuser.id] = true;

    let msg_key = this.afdb_ref.ref().child('messages').push().key;
    updates['/messages/' + msg_key + '/message']  = this.chatMsgVal;
    updates['/messages/' + msg_key + '/timeSent']  = this.getTimeStamp();
    updates['/messages/' + msg_key + '/userName']  = this.stdconuser.prenom + ' ' + this.stdconuser.nom;
    updates['/messages/' + msg_key + '/user'] = 'user_' + this.stdconuser.id;
    updates['/messages/' + msg_key + '/conversation'] = convo_key;

    updates['/conversations/' + convo_key + '/messages/' + msg_key] = true;
    
    updates['/conversations/' + convo_key + '/stand'] = 'stand_' + this.stand_basic.stand_id;

    updates['/users/' + this.stdconuser.id + '/conversations/' + convo_key] = true;
    updates['/users/' + this.stdconuser.id + '/messages/' + msg_key] = true;

    updates['/stands/stand_' + this.stand_basic.stand_id + '/conversations/' + convo_key] = true;
    
    this.chatMsgVal = null;
    return this.afdb_ref.ref().update(updates);
  }


  getStandConvosByUser(){
    console.log('getting stand convos...')
    let temp_convo = this.afdb_ref.ref().child('conversations').orderByChild('stand').equalTo('stand_'+this.stand_basic.stand_id)
    temp_convo.on('value', (snapshot) => {
      let fres = snapshot.val();
      if(fres){
        let ov = Object.values(fres);
        this.standConvos = ov.filter(e => e['users'].filter(ce => ce.id == this.stdconuser.id).length).sort((a,b) => { return b['lastTimeStamp'] - a['lastTimeStamp']});
        this.receiverHasSeen();
        this.cdr.detectChanges();
      }
    })
  }

  getConvoMessages(){
    console.log('getting convo messages...')
    let temp_msgs = this.afdb_ref.ref().child('messages').orderByChild('conversation').equalTo(this.selected_convo.convo_key)
    temp_msgs.on('value', (snapshot) => {
      let fres = snapshot.val();
      if(fres){
        let ov = Object.values(fres).filter(e => e['conversation'] == this.selected_convo.convo_key);
        if(ov.length > 0 && this.selected_convo.convo_key){
          this.selected_convo.messages = ov;
          this.cdr.detectChanges();
        }
      }
    })
  }

  getTimeStamp(){
    let dt = new Date();
    return dt.getDate() + '-' + (dt.getMonth()+1) + '-' + dt.getFullYear() + ' | ' + dt.getHours() + ':' + dt.getMinutes();
  }

}
